module.exports = __webpack_public_path__ + "img/email-white.cf4fb549.svg";